<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    x="0px"
    y="0px"
  >
    <title>Close</title>
    <line
      x1="0"
      y1="0"
      x2="100"
      y2="100"
      fill="none"
      stroke="black"
      stroke-width="1"
      stroke-linecap="round"
      vector-effect="non-scaling-stroke"
    />
    <line
      x1="100"
      y1="0"
      x2="0"
      y2="100"
      fill="none"
      stroke="black"
      stroke-width="1"
      stroke-linecap="round"
      vector-effect="non-scaling-stroke"
    />
  </svg>
</template>
<script setup lang="ts"></script>
